/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateTeamBody
 */
export interface UpdateTeamBody {
  /**
   *
   * @type {string}
   * @memberof UpdateTeamBody
   */
  teamId: string;
  /**
   *
   * @type {string}
   * @memberof UpdateTeamBody
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof UpdateTeamBody
   */
  description?: string | null;
}

/**
 * Check if a given object implements the UpdateTeamBody interface.
 */
export function instanceOfUpdateTeamBody(
  value: object,
): value is UpdateTeamBody {
  if (!("teamId" in value) || value["teamId"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function UpdateTeamBodyFromJSON(json: any): UpdateTeamBody {
  return UpdateTeamBodyFromJSONTyped(json, false);
}

export function UpdateTeamBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateTeamBody {
  if (json == null) {
    return json;
  }
  return {
    teamId: json["teamId"],
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
  };
}

export function UpdateTeamBodyToJSON(json: any): UpdateTeamBody {
  return UpdateTeamBodyToJSONTyped(json, false);
}

export function UpdateTeamBodyToJSONTyped(
  value?: UpdateTeamBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamId: value["teamId"],
    name: value["name"],
    description: value["description"],
  };
}
